import { render, staticRenderFns } from "./PerformanceReviewGroup.vue?vue&type=template&id=f5e9fb6c&scoped=true&"
import script from "./PerformanceReviewGroup.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewGroup.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewGroup.vue?vue&type=style&index=0&id=f5e9fb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e9fb6c",
  null
  
)

export default component.exports